/* eslint-disable */
import { colors } from '../../helper/constant/colors';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { THAI_PROVINCES } from '../../helper/constant';
import {
  getJobCurrentUser,
  JOB_CAREER_CATEGORIES,
  SUGGESTED_SKILLS_BY_CATEGORY,
  DEFAULT_SUGGESTED_SKILLS,
  sanitizeJobProfileResponse,
  withStableRowIds,
  getFriendlyErrorMsg,
} from './jobUtils';
import './JobProfileDashboard.css';

const CAREER_CATEGORIES = JOB_CAREER_CATEGORIES;

function JobProfileDashboard({ regName, regEmail, permitdata, app_hostname }) {
  const location = useLocation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const resumeInputRef = useRef(null);

  const [activeTab, setActiveTab] = useState('profile');
  const [currentStep, setCurrentStep] = useState(1); // 1 to 6 Stepper Wizard

  // Dynamic application & bookmark states
  const [applications, setApplications] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);
  const [savedJobs, setSavedJobs] = useState([]);
  const [loadingSaved, setLoadingSaved] = useState(false);

  // Profile Form State with full schema support
  const [profileData, setProfileData] = useState({
    prefix: 'นาย',
    fullName: regName || '',
    email: regEmail || '',
    phone: permitdata?.phone || '',
    lineId: '',
    birthdate: '',
    gender: 'ชาย',
    province: 'กรุงเทพมหานคร',
    district: '',
    address: '',
    status: 'เปิดรับงานอยู่ 100%',
    isLookingForJob: true,
    avatar: '',
    targetTitle: '',
    categoryId: null, // Dynamic, requires user selection
    categoryName: '',
    expectedSalary: '',
    experienceYears: '0',
    jobTypes: ['Full-time'],
    workHistoryList: [],
    educationList: [],
    skills: [],
    resumeUrl: '',
    resumeFileName: '',
    resumeFileSize: 0,
  });

  const [emailAlerts, setEmailAlerts] = useState(() => {
    const saved = localStorage.getItem('job_settings_email_alerts');
    return saved !== null ? saved === 'true' : true;
  });
  const [publicProfile, setPublicProfile] = useState(() => {
    const saved = localStorage.getItem('job_settings_public_profile');
    return saved !== null ? saved === 'true' : true;
  });

  const [alertSaved, setAlertSaved] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [isSaving, setIsSaving] = useState(false);
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
  const [isUploadingResume, setIsUploadingResume] = useState(false);
  const [newSkillInput, setNewSkillInput] = useState('');

  const showAlert = (msg, type = 'success') => {
    setAlertSaved(msg);
    setAlertType(type);
    setTimeout(() => {
      setAlertSaved('');
    }, 4000);
  };

  const handleToggleEmailAlerts = (e) => {
    const val = e.target.checked;
    setEmailAlerts(val);
    localStorage.setItem('job_settings_email_alerts', String(val));
    showAlert(
      val
        ? 'เปิดรับการแจ้งเตือนงานใหม่ทางอีเมลแล้ว'
        : 'ปิดรับการแจ้งเตือนงานใหม่ทางอีเมลแล้ว',
      'success',
    );
  };

  const handleTogglePublicProfile = (e) => {
    const val = e.target.checked;
    setPublicProfile(val);
    localStorage.setItem('job_settings_public_profile', String(val));
    showAlert(
      val
        ? 'เปิดแสดงโปรไฟล์เป็นสาธารณะแล้ว (สถานพยาบาลสามารถค้นหาคุณได้)'
        : 'ปิดการแสดงโปรไฟล์เป็นสาธารณะแล้ว (โปรไฟล์ของคุณจะเป็นส่วนตัว)',
      'info',
    );
  };

  const fetchMyApplications = async () => {
    const seekerId = getJobCurrentUser(permitdata).userId;
    if (!seekerId) return;
    setLoadingApps(true);
    try {
      const res = await axios.post((app_hostname || '') + '/api/market/jobs/my_applications', {
        seeker_id: seekerId,
      });
      if (res.data && res.data.status === 'Success') {
        setApplications(res.data.data?.items || []);
      }
    } catch (err) {
      // ignore
    } finally {
      setLoadingApps(false);
    }
  };

  const fetchMyBookmarks = async () => {
    const { userId } = getJobCurrentUser(permitdata);
    if (!userId) return;
    setLoadingSaved(true);
    try {
      const res = await axios.post((app_hostname || '') + '/api/market/jobs/my_bookmarks', {
        user_id: userId,
      });
      if (res.data && res.data.status === 'Success') {
        setSavedJobs(res.data.data?.items || []);
      }
    } catch (err) {
      // ignore
    } finally {
      setLoadingSaved(false);
    }
  };

  const fetchMyProfile = async () => {
    const { userId, phone } = getJobCurrentUser(permitdata);
    if (!userId && !phone) return;

    try {
      const res = await axios.post((app_hostname || '') + '/api/account/job/profile/read', {
        user_id: userId,
        phone: phone,
      });
      if (res.data && res.data.status === 'Success' && res.data.data) {
        const p = res.data.data;
        let parsedWork = [];
        let parsedEdu = [];
        let parsedSkills = [];
        let parsedJobTypes = ['Full-time'];

        try {
          if (p.work_history)
            parsedWork =
              typeof p.work_history === 'string' ? JSON.parse(p.work_history) : p.work_history;
        } catch (e) {}
        try {
          if (p.education)
            parsedEdu = typeof p.education === 'string' ? JSON.parse(p.education) : p.education;
        } catch (e) {}
        try {
          if (p.skills)
            parsedSkills = typeof p.skills === 'string' ? JSON.parse(p.skills) : p.skills;
        } catch (e) {}
        try {
          if (p.job_type_preferences)
            parsedJobTypes =
              typeof p.job_type_preferences === 'string'
                ? JSON.parse(p.job_type_preferences)
                : p.job_type_preferences;
        } catch (e) {}

        const sanitized = sanitizeJobProfileResponse(p, regName);
        const resolvedCategoryId = sanitized ? sanitized.categoryId : (p.category_id && p.category_id !== 0 ? Number(p.category_id) : null);
        const matchedCat = resolvedCategoryId ? CAREER_CATEGORIES.find((c) => Number(c.id) === Number(resolvedCategoryId)) : null;

        setProfileData((prev) => ({
          ...prev,
          prefix: p.prefix || prev.prefix || 'นาย',
          fullName: (sanitized && sanitized.fullName) || p.full_name || prev.fullName,
          headline: sanitized ? sanitized.headline : (p.headline || prev.headline),
          targetTitle: sanitized ? sanitized.targetTitle : (p.headline || prev.targetTitle),
          birthdate: p.birthdate || prev.birthdate || '',
          gender: p.gender || prev.gender || 'ชาย',
          categoryId: resolvedCategoryId !== null ? resolvedCategoryId : prev.categoryId,
          categoryName: matchedCat ? matchedCat.title : (resolvedCategoryId ? prev.categoryName : ''),
          province: p.province || prev.province || 'กรุงเทพมหานคร',
          district: p.district || prev.district || '',
          address: p.address || prev.address || '',
          phone: p.phone || prev.phone,
          email: p.email || prev.email,
          lineId: p.line_id || prev.lineId || '',
          expectedSalary: p.expected_salary ? String(p.expected_salary) : prev.expectedSalary,
          experienceYears:
            p.experience_years !== undefined ? String(p.experience_years) : prev.experienceYears,
          jobTypes:
            Array.isArray(parsedJobTypes) && parsedJobTypes.length > 0
              ? parsedJobTypes
              : prev.jobTypes,
          status:
            p.is_looking_for_job === false ? 'ยังไม่เปิดรับงานในขณะนี้' : 'เปิดรับงานอยู่ 100%',
          isLookingForJob:
            p.is_looking_for_job !== undefined ? Boolean(p.is_looking_for_job) : true,
          resumeUrl: p.resume_file_url || prev.resumeUrl,
          resumeFileName: p.resume_file_url
            ? p.resume_file_url.split('/').pop()
            : prev.resumeFileName,
          avatar: p.avatar_url || prev.avatar,
          skills:
            Array.isArray(parsedSkills) && parsedSkills.length > 0 ? parsedSkills : prev.skills,
          workHistoryList:
            Array.isArray(parsedWork) && parsedWork.length > 0
              ? withStableRowIds(parsedWork, 'work')
              : prev.workHistoryList,
          educationList:
            Array.isArray(parsedEdu) && parsedEdu.length > 0
              ? withStableRowIds(parsedEdu, 'edu')
              : prev.educationList,
        }));
      }
    } catch (err) {
      // ignore
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      setActiveTab(tabParam);
    }
    fetchMyApplications();
    fetchMyBookmarks();
    fetchMyProfile();
  }, [location]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`/jobs/profile?tab=${tab}`, { replace: true });
    if (tab === 'history') fetchMyApplications();
    if (tab === 'saved_jobs') fetchMyBookmarks();
  };

  // Dynamic Profile Completeness Percentage Calculation
  const calculateCompleteness = () => {
    let score = 0;
    if (profileData.fullName) score += 15;
    if (profileData.phone) score += 10;
    if (profileData.email) score += 10;
    if (profileData.avatar) score += 10;
    if (profileData.targetTitle) score += 15;
    if (profileData.expectedSalary) score += 10;
    if (profileData.workHistoryList && profileData.workHistoryList.length > 0) score += 10;
    if (profileData.educationList && profileData.educationList.length > 0) score += 10;
    if (profileData.skills && profileData.skills.length > 0) score += 5;
    if (profileData.resumeUrl) score += 5;
    return Math.min(100, Math.max(15, score));
  };

  // Avatar Upload Handler
  const handleAvatarFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      showAlert('ขนาดรูปภาพต้องไม่เกิน 5 MB', 'error');
      return;
    }

    setIsUploadingAvatar(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'avatar');
      const res = await axios.post(
        (app_hostname || '') + '/api/market/jobs/upload_image',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (res.data && res.data.status === 'Success' && res.data.data?.file_url) {
        setProfileData((prev) => ({ ...prev, avatar: res.data.data.file_url }));
        showAlert('อัปโหลดรูปโปรไฟล์สำเร็จ!', 'success');
      } else {
        showAlert(getFriendlyErrorMsg(res.data?.message, 'อัปโหลดรูปไม่สำเร็จ'), 'error');
      }
    } catch (err) {
      showAlert('เกิดข้อผิดพลาดในการอัปโหลดรูปโปรไฟล์', 'error');
    } finally {
      setIsUploadingAvatar(false);
    }
  };

  // Resume File Upload Handler
  const handleResumeFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      showAlert('ขนาดไฟล์เรซูเม่ต้องไม่เกิน 10 MB', 'error');
      return;
    }

    setIsUploadingResume(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axios.post(
        (app_hostname || '') + '/api/market/jobs/upload_resume',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (res.data && res.data.status === 'Success' && res.data.data?.file_url) {
        setProfileData((prev) => ({
          ...prev,
          resumeUrl: res.data.data.file_url,
          resumeFileName: res.data.data.file_name || file.name,
          resumeFileSize: res.data.data.file_size || file.size,
        }));
        showAlert('อัปโหลดเอกสารเรซูเม่เรียบร้อยแล้ว!', 'success');
      } else {
        showAlert(getFriendlyErrorMsg(res.data?.message, 'อัปโหลดเรซูเม่ไม่สำเร็จ'), 'error');
      }
    } catch (err) {
      showAlert('เกิดข้อผิดพลาดในการอัปโหลดเรซูเม่', 'error');
    } finally {
      setIsUploadingResume(false);
    }
  };

  const handleRemoveResume = () => {
    setProfileData((prev) => ({
      ...prev,
      resumeUrl: '',
      resumeFileName: '',
      resumeFileSize: 0,
    }));
    showAlert('ลบเอกสารเรซูเม่เรียบร้อยแล้ว', 'info');
  };

  // Save Profile Handler (Supports Save Draft & Publish)
  const handleSaveProfile = async (isPublish = false) => {
    if (!profileData.fullName.trim()) {
      showAlert('กรุณาระบุชื่อ-นามสกุล', 'error');
      setCurrentStep(1);
      return;
    }
    if (!profileData.phone.trim()) {
      showAlert('กรุณาระบุหมายเลขโทรศัพท์', 'error');
      setCurrentStep(1);
      return;
    }
    if (!profileData.categoryId) {
      showAlert('กรุณาเลือกสายงาน / วิชาชีพหลัก', 'error');
      setCurrentStep(2);
      return;
    }

    setIsSaving(true);
    const currentUserId = getJobCurrentUser(permitdata).userId;
    const cleanSalary = Number(String(profileData.expectedSalary).replace(/,/g, '')) || 0;
    const cleanExp = parseInt(profileData.experienceYears, 10) || 0;

    const payload = {
      user_id: currentUserId,
      phone: profileData.phone.trim(),
      prefix: profileData.prefix || 'นาย',
      full_name: profileData.fullName.trim(),
      headline: (profileData.targetTitle || profileData.headline || '').trim(),
      birthdate: profileData.birthdate || '',
      gender: profileData.gender || 'ชาย',
      category_id: Number(profileData.categoryId),
      province: profileData.province || 'กรุงเทพมหานคร',
      district: (profileData.district || '').trim(),
      address: (profileData.address || '').trim(),
      expected_salary: cleanSalary,
      experience_years: cleanExp,
      avatar_url: profileData.avatar || '',
      resume_file_url: profileData.resumeUrl || '',
      job_type_preferences: JSON.stringify(profileData.jobTypes || ['Full-time']),
      is_looking_for_job: profileData.status !== 'ยังไม่เปิดรับงานในขณะนี้',
      email: (profileData.email || '').trim(),
      line_id: (profileData.lineId || '').trim(),
      work_history: JSON.stringify(profileData.workHistoryList || []),
      education: JSON.stringify(profileData.educationList || []),
      skills: JSON.stringify(profileData.skills || []),
    };

    try {
      const res = await axios.post(
        (app_hostname || '') + '/api/account/job/profile/update',
        payload,
      );
      if (res.data && res.data.status === 'Success') {
        showAlert(
          isPublish
            ? 'บันทึกและเปิดใช้งานโปรไฟล์สาธารณะสำเร็จ 100%!'
            : 'บันทึกข้อมูลโปรไฟล์เรียบร้อยแล้ว',
          'success',
        );
      } else {
        showAlert(getFriendlyErrorMsg(res.data?.message, 'ไม่สามารถบันทึกข้อมูลได้'), 'error');
      }
    } catch (err) {
      showAlert('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  // Work Experience Dynamic Handlers
  const handleAddWorkExp = () => {
    const newId = Date.now();
    setProfileData((prev) => ({
      ...prev,
      workHistoryList: [
        ...prev.workHistoryList,
        { id: newId, company: '', position: '', period: '', description: '' },
      ],
    }));
  };

  const handleWorkChange = (id, field, value) => {
    setProfileData((prev) => ({
      ...prev,
      workHistoryList: prev.workHistoryList.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    }));
  };

  const handleRemoveWork = (id) => {
    setProfileData((prev) => ({
      ...prev,
      workHistoryList: prev.workHistoryList.filter((item) => item.id !== id),
    }));
    showAlert('ลบรายการประวัติการทำงานแล้ว', 'info');
  };

  // Education Dynamic Handlers
  const handleAddEducation = () => {
    const newId = Date.now();
    setProfileData((prev) => ({
      ...prev,
      educationList: [
        ...prev.educationList,
        { id: newId, degree: '', university: '', major: '', gpa: '', year: '' },
      ],
    }));
  };

  const handleEduChange = (id, field, value) => {
    setProfileData((prev) => ({
      ...prev,
      educationList: prev.educationList.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    }));
  };

  const handleRemoveEdu = (id) => {
    setProfileData((prev) => ({
      ...prev,
      educationList: prev.educationList.filter((item) => item.id !== id),
    }));
    showAlert('ลบรายการประวัติการศึกษาแล้ว', 'info');
  };

  // Skills Handlers
  const handleAddSkill = (skillToAdd) => {
    const s = (skillToAdd || newSkillInput).trim();
    if (!s) return;
    if (profileData.skills.includes(s)) {
      showAlert('มีทักษะนี้ในรายการแล้ว', 'info');
      setNewSkillInput('');
      return;
    }
    setProfileData((prev) => ({
      ...prev,
      skills: [...prev.skills, s],
    }));
    setNewSkillInput('');
  };

  const handleRemoveSkill = (skillToRemove) => {
    setProfileData((prev) => ({
      ...prev,
      skills: prev.skills.filter((s) => s !== skillToRemove),
    }));
  };

  // Job Type Checkbox Toggle
  const handleToggleJobType = (type) => {
    setProfileData((prev) => {
      const current = prev.jobTypes || [];
      if (current.includes(type)) {
        if (current.length === 1) return prev; // Keep at least one
        return { ...prev, jobTypes: current.filter((t) => t !== type) };
      } else {
        return { ...prev, jobTypes: [...current, type] };
      }
    });
  };

  // Smart Step Completion Evaluator (Real-time check per step)
  const isStepCompleted = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        // ข้อมูลส่วนตัว: ชื่อ-นามสกุล, เบอร์โทร และจังหวัด
        return Boolean(
          profileData.fullName?.trim() && profileData.phone?.trim() && profileData.province?.trim(),
        );
      case 2:
        // เป้าหมายและเงินเดือน: ต้องเลือกสายงานหลัก และระบุตำแหน่งที่ต้องการ
        return Boolean(
          profileData.targetTitle?.trim() && Number(profileData.categoryId) > 0,
        );
      case 3:
        // ประวัติการทำงาน: มีรายการและระบุชื่อบริษัทกับตำแหน่ง
        return Boolean(
          profileData.workHistoryList?.length > 0 &&
            profileData.workHistoryList.some((w) => w.company?.trim() && w.position?.trim()),
        );
      case 4:
        // ประวัติการศึกษา: มีรายการและระบุวุฒิกับสถาบัน
        return Boolean(
          profileData.educationList?.length > 0 &&
            profileData.educationList.some((e) => e.degree?.trim() && e.university?.trim()),
        );
      case 5:
        // ทักษะและความสามารถ: มีอย่างน้อย 1 ทักษะ
        return Boolean(Array.isArray(profileData.skills) && profileData.skills.length > 0);
      case 6:
        // เอกสารแนบ / เรซูเม่: มี URL ไฟล์เรซูเม่ที่อัปโหลด
        return Boolean(profileData.resumeUrl?.trim());
      default:
        return false;
    }
  };

  // Stepper Items configuration
  const STEPPER_ITEMS = [
    {
      step: 1,
      title: 'ข้อมูลส่วนตัว',
      icon: 'mdi-account-outline',
      desc: 'รูปถ่ายและข้อมูลติดต่อ',
    },
    {
      step: 2,
      title: 'เป้าหมายและเงินเดือน',
      icon: 'mdi-briefcase-outline',
      desc: 'ตำแหน่งและสายงาน',
    },
    { step: 3, title: 'ประวัติการทำงาน', icon: 'mdi-history', desc: 'ประสบการณ์ที่ผ่านมา' },
    {
      step: 4,
      title: 'ประวัติการศึกษา',
      icon: 'mdi-school-outline',
      desc: 'วุฒิการศึกษาและสถาบัน',
    },
    {
      step: 5,
      title: 'ทักษะและความสามารถ',
      icon: 'mdi-star-outline',
      desc: 'ใบอนุญาตและทักษะเฉพาะ',
    },
    {
      step: 6,
      title: 'เอกสารแนบ / เรซูเม่',
      icon: 'mdi-file-pdf-box',
      desc: 'Resume PDF & Portfolio',
    },
  ];

  const renderCandidateProfileForm = () => {
    const completeness = calculateCompleteness();

    return (
      <div className='stepper-builder-container'>
        {/* Hidden File Inputs */}
        <input
          type='file'
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept='image/jpeg,image/png,image/webp'
          onChange={handleAvatarFileChange}
        />
        <input
          type='file'
          ref={resumeInputRef}
          style={{ display: 'none' }}
          accept='.pdf,.docx,.doc,.jpg,.png'
          onChange={handleResumeFileChange}
        />

        {alertSaved && (
          <div
            className={`job-alert-toast-${alertType === 'error' ? 'danger' : alertType === 'info' ? 'info' : 'success'}`}
          >
            <i
              className={`mdi ${alertType === 'error' ? 'mdi-alert-circle-outline' : alertType === 'info' ? 'mdi-information-outline' : 'mdi-check-circle-outline'}`}
            ></i>
            <span>{alertSaved}</span>
          </div>
        )}

        {/* Header Bar with Quick Save Action */}
        <div className='builder-header-bar'>
          <div>
            <h2>สร้าง / แก้ไขโปรไฟล์และเรซูเม่ผู้หางาน</h2>
            <p>
              กรอกข้อมูลให้ครบถ้วนเพื่อเพิ่มโอกาสในการถูกติดต่อเสนองานจากร้านยาและสถานพยาบาลชั้นนำ
            </p>
          </div>
          <div className='builder-header-actions'>
            <button
              type='button'
              className='btn-builder-draft-sm'
              disabled={isSaving}
              onClick={() => handleSaveProfile(false)}
            >
              <i className='mdi mdi-content-save-outline'></i> บันทึกฉบับร่าง
            </button>
            <button
              type='button'
              className='btn-builder-publish-sm'
              disabled={isSaving}
              onClick={() => handleSaveProfile(true)}
            >
              <i className='mdi mdi-check-circle-outline'></i>{' '}
              {isSaving ? 'กำลังบันทึก...' : 'บันทึกโปรไฟล์'}
            </button>
          </div>
        </div>

        <div className='builder-stepper-grid'>
          {/* Stepper Sidebar Left */}
          <div className='stepper-sidebar'>
            {/* Dynamic Completeness Card */}
            <div className='stepper-progress-box'>
              <div className='progress-label-row'>
                <span>ความสมบูรณ์ของโปรไฟล์</span>
                <strong className={completeness >= 80 ? 'text-success' : 'text-primary'}>
                  {completeness}%
                </strong>
              </div>
              <div className='progress-track-bg'>
                <div
                  className='progress-fill-bar'
                  style={{
                    width: `${completeness}%`,
                    background: completeness >= 80 ? '#10b981' : colors.blueLight,
                  }}
                ></div>
              </div>
              <p className='completeness-hint'>
                {completeness < 50
                  ? '⚠️ แนะนำกรอกข้อมูลให้เกิน 70% เพื่อให้ผู้ว่าจ้างค้นพบได้ง่าย'
                  : '✅ โปรไฟล์ของคุณมีความพร้อมและน่าเชื่อถือสูง'}
              </p>
            </div>

            {/* Steps List Nav */}
            <div className='stepper-nav-menu'>
              {STEPPER_ITEMS.map((item) => {
                const isCompleted = isStepCompleted(item.step);
                const isActive = currentStep === item.step;
                return (
                  <div
                    key={item.step}
                    className={`stepper-nav-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
                    onClick={() => setCurrentStep(item.step)}
                  >
                    <div className='step-number-badge'>
                      {isCompleted ? <i className='mdi mdi-check'></i> : item.step}
                    </div>
                    <div className='step-title-wrap'>
                      <span className='step-title-text'>{item.title}</span>
                      <span className='step-desc-text'>
                        {isCompleted ? (
                          <span className='step-completed-tag'>กรอกแล้ว</span>
                        ) : (
                          item.desc
                        )}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Form Area (Step-by-Step Wizard) */}
          <div className='stepper-form-panel'>
            {/* STEP 1: ข้อมูลส่วนตัว */}
            {currentStep === 1 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-account-circle-outline'></i>
                  <div>
                    <h3>1. ข้อมูลส่วนตัว (Personal Information)</h3>
                    <p className='section-subtext'>รูปถ่ายและข้อมูลการติดต่อสำหรับผู้ประกอบการ</p>
                  </div>
                </div>

                {/* Avatar Upload */}
                <div className='avatar-upload-row'>
                  <div className='avatar-img-container'>
                    {profileData.avatar ? (
                      <img
                        src={profileData.avatar}
                        alt='Profile Avatar'
                        className='builder-avatar-preview'
                      />
                    ) : (
                      <div className='builder-avatar-placeholder'>
                        <i className='mdi mdi-account'></i>
                      </div>
                    )}
                    {isUploadingAvatar && (
                      <div className='avatar-upload-spinner'>
                        <i className='mdi mdi-loading mdi-spin'></i>
                      </div>
                    )}
                  </div>
                  <div className='avatar-upload-info'>
                    <button
                      type='button'
                      className='btn-upload-avatar'
                      disabled={isUploadingAvatar}
                      onClick={() => fileInputRef.current && fileInputRef.current.click()}
                    >
                      <i className='mdi mdi-camera'></i>{' '}
                      {profileData.avatar ? 'เปลี่ยนรูปโปรไฟล์' : 'อัปโหลดรูปโปรไฟล์'}
                    </button>
                    <p className='upload-hint-text'>
                      รองรับไฟล์ภาพ JPG, PNG ขนาดไม่เกิน 5 MB (แนะนำรูปถ่ายหน้าตรง สุภาพ ชัดเจน)
                    </p>
                  </div>
                </div>

                <div className='builder-form-grid-2'>
                  <div className='form-field-group'>
                    <label>
                      คำนำหน้า <span className='required-star'>*</span>
                    </label>
                    <select
                      value={profileData.prefix}
                      onChange={(e) => setProfileData({ ...profileData, prefix: e.target.value })}
                    >
                      <option value='นาย'>นาย</option>
                      <option value='นาง'>นาง</option>
                      <option value='นางสาว'>นางสาว</option>
                      <option value='ภก.'>ภก. (เภสัชกร)</option>
                      <option value='ภญ.'>ภญ. (เภสัชกรหญิง)</option>
                      <option value='พญ.'>พญ. (แพทย์หญิง)</option>
                      <option value='นพ.'>นพ. (นายแพทย์)</option>
                      <option value='ทพ.'>ทพ. (ทันตแพทย์)</option>
                      <option value='ทพญ.'>ทพญ. (ทันตแพทย์หญิง)</option>
                    </select>
                  </div>

                  <div className='form-field-group'>
                    <label>
                      ชื่อ - นามสกุล <span className='required-star'>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='เช่น ดลยา นวลดี'
                      value={profileData.fullName}
                      onChange={(e) => setProfileData({ ...profileData, fullName: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>เพศ</label>
                    <select
                      value={profileData.gender}
                      onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}
                    >
                      <option value='ชาย'>ชาย</option>
                      <option value='หญิง'>หญิง</option>
                      <option value='ไม่ระบุ'>ไม่ระบุ</option>
                    </select>
                  </div>

                  <div className='form-field-group'>
                    <label>วัน/เดือน/ปีเกิด</label>
                    <input
                      type='date'
                      value={profileData.birthdate}
                      onChange={(e) =>
                        setProfileData({ ...profileData, birthdate: e.target.value })
                      }
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>
                      หมายเลขโทรศัพท์ <span className='required-star'>*</span>
                    </label>
                    <input
                      type='tel'
                      placeholder='เช่น 0812345678'
                      value={profileData.phone}
                      onChange={(e) => setProfileData({ ...profileData, phone: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>อีเมลติดต่อ</label>
                    <input
                      type='email'
                      placeholder='example@email.com'
                      value={profileData.email}
                      onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>LINE ID</label>
                    <input
                      type='text'
                      placeholder='เช่น rx_care'
                      value={profileData.lineId}
                      onChange={(e) => setProfileData({ ...profileData, lineId: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>จังหวัดที่พำนัก / สะดวกทำงาน</label>
                    <select
                      value={profileData.province}
                      onChange={(e) => setProfileData({ ...profileData, province: e.target.value })}
                    >
                      {THAI_PROVINCES.map((prov) => (
                        <option key={prov} value={prov}>
                          {prov}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='form-field-group'>
                    <label>เขต / อำเภอ</label>
                    <input
                      type='text'
                      placeholder='เช่น จตุจักร, ปทุมวัน'
                      value={profileData.district}
                      onChange={(e) => setProfileData({ ...profileData, district: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group full-width'>
                    <label>ที่อยู่ปัจจุบันโดยย่อ</label>
                    <input
                      type='text'
                      placeholder='เช่น 123/45 ถนนพหลโยธิน แขวงจตุจักร'
                      value={profileData.address}
                      onChange={(e) => setProfileData({ ...profileData, address: e.target.value })}
                    />
                  </div>

                  <div className='form-field-group full-width'>
                    <label>สถานะการเปิดรับงาน</label>
                    <select
                      value={profileData.status}
                      onChange={(e) =>
                        setProfileData({
                          ...profileData,
                          status: e.target.value,
                          isLookingForJob: e.target.value !== 'ยังไม่เปิดรับงานในขณะนี้',
                        })
                      }
                    >
                      <option value='เปิดรับงานอยู่ 100%'>
                         เปิดรับงานอยู่ 100% (พร้อมเริ่มงานทันที)
                      </option>
                      <option value='สนใจพิจารณาข้อเสนอ'>
                         สนใจพิจารณาข้อเสนอ (เปิดรับโอกาสใหม่)
                      </option>
                      <option value='ยังไม่เปิดรับงานในขณะนี้'>
                         ยังไม่เปิดรับงานในขณะนี้ (ปิดรับชั่วคราว)
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            )}

            {/* STEP 2: ตำแหน่งงานและเงินเดือน */}
            {currentStep === 2 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-briefcase-outline'></i>
                  <div>
                    <h3>2. ตำแหน่งงานและเงินเดือนที่ต้องการ (Job Preferences)</h3>
                    <p className='section-subtext'>ระบุสายงานและผลตอบแทนที่ตรงกับเป้าหมายของคุณ</p>
                  </div>
                </div>

                <div className='builder-form-grid-2'>
                  <div className='form-field-group'>
                    <label>
                      สายงาน / วิชาชีพหลัก <span className='required-star'>*</span>
                    </label>
                    <select
                      value={profileData.categoryId || ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        const catId = val ? Number(val) : null;
                        const cat = CAREER_CATEGORIES.find((c) => c.id === catId);
                        setProfileData({
                          ...profileData,
                          categoryId: catId,
                          categoryName: cat ? cat.title : '',
                        });
                      }}
                    >
                      <option value=''>-- กรุณาเลือกสายงาน / วิชาชีพหลัก --</option>
                      {CAREER_CATEGORIES.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='form-field-group'>
                    <label>
                      ตำแหน่งงานที่สนใจ (Headline / Target Title){' '}
                      <span className='required-star'>*</span>
                    </label>
                    <input
                      type='text'
                      value={profileData.targetTitle}
                      placeholder='เช่น เภสัชกรประจำร้านยา, เภสัชกรคลินิก, พยาบาลวิชาชีพ'
                      onChange={(e) =>
                        setProfileData({ ...profileData, targetTitle: e.target.value })
                      }
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>เงินเดือนที่คาดหวัง (บาท/เดือน)</label>
                    <input
                      type='text'
                      value={profileData.expectedSalary}
                      placeholder='เช่น 45,000'
                      onChange={(e) =>
                        setProfileData({ ...profileData, expectedSalary: e.target.value })
                      }
                    />
                  </div>

                  <div className='form-field-group'>
                    <label>ประสบการณ์ทำงานรวม (ปี)</label>
                    <input
                      type='number'
                      min='0'
                      max='50'
                      value={profileData.experienceYears}
                      onChange={(e) =>
                        setProfileData({ ...profileData, experienceYears: e.target.value })
                      }
                    />
                  </div>

                  <div className='form-field-group full-width'>
                    <label>รูปแบบงานที่สนใจ (เลือกได้มากกว่า 1 รูปแบบ)</label>
                    <div className='checkbox-options-row'>
                      {['Full-time', 'Part-time', 'สัญญาจ้าง (Contract)', 'เวรเสริม (Relief)'].map(
                        (type) => (
                          <label key={type} className='checkbox-item-label'>
                            <input
                              type='checkbox'
                              checked={(profileData.jobTypes || []).includes(type)}
                              onChange={() => handleToggleJobType(type)}
                            />
                            <span>{type}</span>
                          </label>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP 3: ประวัติการทำงาน */}
            {currentStep === 3 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-history'></i>
                  <div>
                    <h3>3. ประวัติการทำงาน (Work Experience)</h3>
                    <p className='section-subtext'>บอกเล่าประสบการณ์และผลงานที่ผ่านมาของคุณ</p>
                  </div>
                </div>

                <div className='work-exp-dynamic-list'>
                  {profileData.workHistoryList.length === 0 ? (
                    <div className='empty-sublist-box'>
                      <i className='mdi mdi-briefcase-search-outline'></i>
                      <p>ยังไม่มีรายการประวัติการทำงาน กดปุ่มด้านล่างเพื่อเพิ่มประสบการณ์ของคุณ</p>
                    </div>
                  ) : (
                    profileData.workHistoryList.map((item, idx) => (
                      <div key={item.id} className='builder-card-item style-exp-card'>
                        <div className='card-item-header'>
                          <span className='card-item-badge'>สถานที่ทำงาน #{idx + 1}</span>
                          <button
                            type='button'
                            className='btn-delete-card-item'
                            title='ลบรายการนี้'
                            onClick={() => handleRemoveWork(item.id)}
                          >
                            <i className='mdi mdi-trash-can-outline'></i> ลบรายการ
                          </button>
                        </div>

                        <div className='builder-form-grid-2'>
                          <div className='form-field-group'>
                            <label>ชื่อสถานพยาบาล / ร้านยา / บริษัท</label>
                            <input
                              type='text'
                              placeholder='เช่น ร้านยากระปุกโอสถ, โรงพยาบาลกรุงเทพ'
                              value={item.company || ''}
                              onChange={(e) => handleWorkChange(item.id, 'company', e.target.value)}
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>ตำแหน่งงาน</label>
                            <input
                              type='text'
                              placeholder='เช่น เภสัชกรประจำสาขา, เภสัชกร Part-time'
                              value={item.position || ''}
                              onChange={(e) =>
                                handleWorkChange(item.id, 'position', e.target.value)
                              }
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>ระยะเวลาทำงาน</label>
                            <input
                              type='text'
                              placeholder='เช่น 2022 - ปัจจุบัน หรือ 2 ปี'
                              value={item.period || ''}
                              onChange={(e) => handleWorkChange(item.id, 'period', e.target.value)}
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>หน้าที่และความรับผิดชอบโดยย่อ</label>
                            <input
                              type='text'
                              placeholder='เช่น จ่ายยา, บริหารสต็อกยา, ให้คำปรึกษาคนไข้'
                              value={item.description || ''}
                              onChange={(e) =>
                                handleWorkChange(item.id, 'description', e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                <button
                  type='button'
                  className='btn-add-experience mt-3'
                  onClick={handleAddWorkExp}
                >
                  <i className='mdi mdi-plus-circle'></i> เพิ่มประวัติการทำงาน
                </button>
              </div>
            )}

            {/* STEP 4: ประวัติการศึกษา */}
            {currentStep === 4 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-school-outline'></i>
                  <div>
                    <h3>4. ประวัติการศึกษา (Education)</h3>
                    <p className='section-subtext'>วุฒิการศึกษาและสถาบันการศึกษาของคุณ</p>
                  </div>
                </div>

                <div className='education-dynamic-list'>
                  {profileData.educationList.length === 0 ? (
                    <div className='empty-sublist-box'>
                      <i className='mdi mdi-school-outline'></i>
                      <p>ยังไม่มีรายการประวัติการศึกษา กดปุ่มด้านล่างเพื่อเพิ่มข้อมูล</p>
                    </div>
                  ) : (
                    profileData.educationList.map((item, idx) => (
                      <div key={item.id} className='builder-card-item style-edu-card'>
                        <div className='card-item-header'>
                          <span className='card-item-badge'>วุฒิการศึกษา #{idx + 1}</span>
                          <button
                            type='button'
                            className='btn-delete-card-item'
                            title='ลบรายการนี้'
                            onClick={() => handleRemoveEdu(item.id)}
                          >
                            <i className='mdi mdi-trash-can-outline'></i> ลบรายการ
                          </button>
                        </div>

                        <div className='builder-form-grid-2'>
                          <div className='form-field-group'>
                            <label>ระดับ / วุฒิการศึกษา</label>
                            <input
                              type='text'
                              placeholder='เช่น ปริญญาตรี เภสัชศาสตรบัณฑิต (ภ.บ.)'
                              value={item.degree || ''}
                              onChange={(e) => handleEduChange(item.id, 'degree', e.target.value)}
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>สถาบันการศึกษา / มหาวิทยาลัย</label>
                            <input
                              type='text'
                              placeholder='เช่น จุฬาลงกรณ์มหาวิทยาลัย, มหาวิทยาลัยมหิดล'
                              value={item.university || ''}
                              onChange={(e) =>
                                handleEduChange(item.id, 'university', e.target.value)
                              }
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>สาขาวิชา / ภาควิชา</label>
                            <input
                              type='text'
                              placeholder='เช่น เภสัชกรรมบริบาล, บริบาลเภสัชกรรม'
                              value={item.major || ''}
                              onChange={(e) => handleEduChange(item.id, 'major', e.target.value)}
                            />
                          </div>

                          <div className='form-field-group'>
                            <label>เกรดเฉลี่ย (GPA)</label>
                            <input
                              type='text'
                              placeholder='เช่น 3.65'
                              value={item.gpa || ''}
                              onChange={(e) => handleEduChange(item.id, 'gpa', e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                <button
                  type='button'
                  className='btn-add-experience mt-3'
                  onClick={handleAddEducation}
                >
                  <i className='mdi mdi-plus-circle'></i> เพิ่มประวัติการศึกษา
                </button>
              </div>
            )}

            {/* STEP 5: ทักษะและความสามารถ */}
            {currentStep === 5 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-star-outline'></i>
                  <div>
                    <h3>5. ทักษะและความสามารถ (Skills & Certifications)</h3>
                    <p className='section-subtext'>
                      เลือกทักษะเด่นหรือพิมพ์เพิ่มเอง เพื่อช่วยให้นายจ้างค้นพบตรงสายงาน
                    </p>
                  </div>
                </div>

                {/* Current Skills Chips */}
                <div className='skills-section-wrap'>
                  <label className='field-sublabel'>ทักษะของคุณในปัจจุบัน:</label>
                  {profileData.skills.length === 0 ? (
                    <p className='text-muted-skills'>
                      ยังไม่ได้เพิ่มทักษะ เลือกจากทักษะแนะนำด้านล่าง หรือพิมพ์เพิ่มเอง
                    </p>
                  ) : (
                    <div className='skill-builder-tags mb-3'>
                      {profileData.skills.map((s, idx) => (
                        <span key={idx} className='builder-skill-chip'>
                          {s}{' '}
                          <i
                            className='mdi mdi-close'
                            title='ลบ'
                            onClick={() => handleRemoveSkill(s)}
                          ></i>
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Add New Custom Skill Input */}
                  <div className='custom-skill-input-row mt-3'>
                    <input
                      type='text'
                      placeholder='พิมพ์ทักษะหรือใบรับรองใหม่ เช่น ใบอนุญาตประกอบโรคศิลปะ, POS...'
                      value={newSkillInput}
                      onChange={(e) => setNewSkillInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleAddSkill();
                        }
                      }}
                    />
                    <button
                      type='button'
                      className='btn-add-skill-action'
                      onClick={() => handleAddSkill()}
                    >
                      <i className='mdi mdi-plus'></i> เพิ่มทักษะ
                    </button>
                  </div>

                  {/* Suggested Quick Add Skills */}
                  {(() => {
                    const activeSuggestedSkills = profileData.categoryId
                      ? (SUGGESTED_SKILLS_BY_CATEGORY[profileData.categoryId] || DEFAULT_SUGGESTED_SKILLS)
                      : DEFAULT_SUGGESTED_SKILLS;
                    const categoryLabel = profileData.categoryName
                      ? `สายงาน${profileData.categoryName}`
                      : 'สายสุขภาพทั่วไป';

                    return (
                      <div className='suggested-skills-block mt-4'>
                        <label className='field-sublabel'>
                          ⚡ ทักษะแนะนำสำหรับ{categoryLabel} (คลิกเพื่อเพิ่มทันที):
                        </label>
                        <div className='suggested-tags-list'>
                          {activeSuggestedSkills.map((item) => {
                            const isSelected = profileData.skills.includes(item);
                            return (
                              <button
                                key={item}
                                type='button'
                                className={`btn-suggest-skill ${isSelected ? 'selected' : ''}`}
                                onClick={() => !isSelected && handleAddSkill(item)}
                              >
                                {isSelected ? (
                                  <i className='mdi mdi-check'></i>
                                ) : (
                                  <i className='mdi mdi-plus'></i>
                                )}{' '}
                                {item}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
            )}

            {/* STEP 6: เอกสารแนบและเรซูเม่ */}
            {currentStep === 6 && (
              <div className='form-section-block step-fade-in'>
                <div className='section-block-header'>
                  <i className='mdi mdi-file-pdf-box'></i>
                  <div>
                    <h3>6. เอกสารแนบและเรซูเม่ (Resume & Documents)</h3>
                    <p className='section-subtext'>
                      อัปโหลดไฟล์เรซูเม่ฉบับสมบูรณ์เพื่อให้ผู้ประกอบการดาวน์โหลดพิจารณา
                    </p>
                  </div>
                </div>

                {profileData.resumeUrl ? (
                  <div className='uploaded-resume-card'>
                    <div className='resume-card-left'>
                      <div className='resume-icon-badge'>
                        <i className='mdi mdi-file-pdf-box'></i>
                      </div>
                      <div className='resume-card-meta'>
                        <h4>{profileData.resumeFileName || 'เอกสารเรซูเม่'}</h4>
                        <span className='resume-file-size'>
                          {profileData.resumeFileSize
                            ? `${(profileData.resumeFileSize / (1024 * 1024)).toFixed(2)} MB`
                            : 'พร้อมใช้งาน'}
                        </span>
                      </div>
                    </div>
                    <div className='resume-card-actions'>
                      <a
                        href={
                          profileData.resumeUrl.startsWith('http')
                            ? profileData.resumeUrl
                            : (app_hostname || '') + profileData.resumeUrl
                        }
                        target='_blank'
                        rel='noopener noreferrer'
                        className='btn-preview-resume'
                      >
                        <i className='mdi mdi-eye-outline'></i> ดูตัวอย่าง
                      </a>
                      <button
                        type='button'
                        className='btn-replace-resume'
                        disabled={isUploadingResume}
                        onClick={() => resumeInputRef.current && resumeInputRef.current.click()}
                      >
                        <i className='mdi mdi-refresh'></i> เปลี่ยนไฟล์
                      </button>
                      <button
                        type='button'
                        className='btn-delete-resume'
                        onClick={handleRemoveResume}
                      >
                        <i className='mdi mdi-trash-can-outline'></i>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    className='resume-dropzone-box'
                    onClick={() => resumeInputRef.current && resumeInputRef.current.click()}
                  >
                    <div className='dropzone-inner'>
                      <i
                        className={`mdi ${isUploadingResume ? 'mdi-loading mdi-spin' : 'mdi-cloud-upload-outline'}`}
                      ></i>
                      <h4>
                        {isUploadingResume
                          ? 'กำลังอัปโหลดไฟล์เรซูเม่...'
                          : 'คลิกเพื่อเลือกไฟล์ หรือลากไฟล์มาวางที่นี่'}
                      </h4>
                      <p>รองรับไฟล์ PDF, DOCX, DOC, JPG, PNG ขนาดไม่เกิน 10 MB</p>
                      <button
                        type='button'
                        className='btn-choose-file-resume'
                        disabled={isUploadingResume}
                      >
                        เลือกไฟล์จากอุปกรณ์
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Stepper Navigation Footer Buttons */}
            <div className='builder-wizard-navigation'>
              <div className='wizard-nav-left'>
                {currentStep > 1 && (
                  <button
                    type='button'
                    className='btn-wizard-prev'
                    onClick={() => setCurrentStep((prev) => prev - 1)}
                  >
                    <i className='mdi mdi-arrow-left'></i> ย้อนกลับ
                  </button>
                )}
              </div>

              <div className='wizard-nav-right'>
                <button
                  type='button'
                  className='btn-builder-draft'
                  disabled={isSaving}
                  onClick={() => handleSaveProfile(false)}
                >
                  บันทึกฉบับร่าง
                </button>

                {currentStep < 6 ? (
                  <button
                    type='button'
                    className='btn-wizard-next'
                    onClick={() => setCurrentStep((prev) => prev + 1)}
                  >
                    ขั้นตอนถัดไป <i className='mdi mdi-arrow-right'></i>
                  </button>
                ) : (
                  <button
                    type='button'
                    className='btn-builder-publish'
                    disabled={isSaving}
                    onClick={() => handleSaveProfile(true)}
                  >
                    <i className='mdi mdi-check-circle-outline'></i>{' '}
                    {isSaving ? 'กำลังบันทึก...' : 'บันทึกและเปิดใช้งานโปรไฟล์'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'edit_candidate':
      case 'profile':
        return renderCandidateProfileForm();
      case 'searches':
        return (
          <div className='dashboard-content-panel'>
            <h2>บันทึกการค้นหา</h2>
            <p className='dashboard-subtitle'>คำค้นหาและตัวกรองที่คุณบันทึกไว้</p>
            <div className='saved-item-card'>
              <div className='saved-item-info'>
                <h4>พยาบาลวิชาชีพ กรุงเทพมหานคร</h4>
                <span>ค้นหาล่าสุด: เมื่อวานนี้</span>
              </div>
              <button className='btn-outline-primary' onClick={() => navigate('/jobs')}>
                ค้นหาอีกครั้ง
              </button>
            </div>
            <div className='saved-item-card'>
              <div className='saved-item-info'>
                <h4>เภสัชกร จบใหม่</h4>
                <span>ค้นหาล่าสุด: 3 วันที่แล้ว</span>
              </div>
              <button className='btn-outline-primary' onClick={() => navigate('/jobs')}>
                ค้นหาอีกครั้ง
              </button>
            </div>
          </div>
        );
      case 'saved_jobs':
        return (
          <div className='dashboard-content-panel'>
            <h2>งานที่บันทึก</h2>
            <p className='dashboard-subtitle'>ตำแหน่งงานที่คุณสนใจและกดบันทึกไว้</p>
            {loadingSaved ? (
              <p style={{ color: colors.gray8c }}>กำลังโหลดงานที่บันทึกไว้...</p>
            ) : savedJobs.length === 0 ? (
              <div
                className='empty-history'
                style={{ textAlign: 'center', padding: '40px 0', color: colors.gray8c }}
              >
                <i className='mdi mdi-heart-outline' style={{ fontSize: 40 }}></i>
                <p style={{ marginTop: 12 }}>ยังไม่มีงานที่บันทึกไว้</p>
                <button className='btn-outline-primary' onClick={() => navigate('/jobs')}>
                  ไปค้นหาตำแหน่งงาน
                </button>
              </div>
            ) : (
              savedJobs.map((item) => (
                <div className='saved-item-card' key={item.bookmark_id || item.job_id || item.id}>
                  <div className='saved-item-info'>
                    <h4>{item.title}</h4>
                    <span>
                      {item.company_name} | {item.province} | {item.salary_text}
                    </span>
                  </div>
                  <button
                    className='btn-outline-primary'
                    onClick={() => navigate(`/jobs/detail/${item.job_id || item.id}`)}
                  >
                    ดูรายละเอียด
                  </button>
                </div>
              ))
            )}
          </div>
        );
      case 'history':
        return (
          <div className='dashboard-content-panel'>
            <h2>ประวัติการสมัครงาน</h2>
            <p className='dashboard-subtitle'>ติดตามสถานะการสมัครงานของคุณ</p>
            <div className='history-table-container'>
              {loadingApps ? (
                <p style={{ color: colors.gray8c }}>กำลังโหลดประวัติการสมัครงาน...</p>
              ) : applications.length === 0 ? (
                <div
                  className='empty-history'
                  style={{ textAlign: 'center', padding: '40px 0', color: colors.gray8c }}
                >
                  <i className='mdi mdi-file-document-outline' style={{ fontSize: 40 }}></i>
                  <p style={{ marginTop: 12 }}>ยังไม่มีประวัติการสมัครงาน</p>
                  <button className='btn-outline-primary' onClick={() => navigate('/jobs')}>
                    ไปค้นหาตำแหน่งงาน
                  </button>
                </div>
              ) : (
                <table className='history-table'>
                  <thead>
                    <tr>
                      <th>ตำแหน่งงาน</th>
                      <th>สถานประกอบการ</th>
                      <th>วันที่สมัคร</th>
                      <th>สถานะ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {applications.map((app) => {
                      let badgeClass = 'pending';
                      let statusText = 'รอพิจารณา';
                      if (app.status === 'interview') {
                        badgeClass = 'success';
                        statusText = 'เรียกสัมภาษณ์';
                      } else if (app.status === 'accepted' || app.status === 'hired') {
                        badgeClass = 'success';
                        statusText = 'ผ่านการคัดเลือก';
                      } else if (app.status === 'rejected') {
                        badgeClass = 'danger';
                        statusText = 'ไม่ผ่านการคัดเลือก';
                      }

                      return (
                        <tr key={app.application_id || app.id}>
                          <td>
                            <span
                              style={{ color: colors.blue1890ff, cursor: 'pointer', fontWeight: 500 }}
                              onClick={() => navigate(`/jobs/detail/${app.job_id}`)}
                            >
                              {app.job_title}
                            </span>
                            {app.employer_notes && (
                              <div style={{ fontSize: 12, color: colors.gray8c, marginTop: 4, whiteSpace: 'pre-line' }}>
                                <i className='mdi mdi-information-outline me-1'></i>
                                โน้ตจากผู้ว่าจ้าง: {app.employer_notes}
                              </div>
                            )}
                          </td>
                          <td>{app.company_name}</td>
                          <td>{app.created_at ? app.created_at.split(' ')[0] : '-'}</td>
                          <td>
                            <span className={`status-badge ${badgeClass}`}>{statusText}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        );
      case 'notifications':
        return (
          <div className='dashboard-content-panel'>
            <h2>การแจ้งเตือนของคุณ</h2>
            <p className='dashboard-subtitle'>อัปเดตสถานะจากผู้ประกอบการและข่าวสาร</p>
            <div className='job-empty-state' style={{ padding: '60px 20px', textAlign: 'center' }}>
              <i className='mdi mdi-bell-off-outline' style={{ fontSize: '48px', color: colors.gray400 }}></i>
              <h3 style={{ marginTop: '16px', color: colors.gray700 }}>ยังไม่มีการแจ้งเตือนในขณะนี้</h3>
              <p style={{ color: colors.gray500, fontSize: '14px', maxWidth: '420px', margin: '8px auto 0' }}>
                เมื่อมีผู้ประกอบการติดต่อหรืออัปเดตสถานะการสมัครงานของคุณ ระบบจะแสดงการแจ้งเตือนที่นี่
              </p>
            </div>
          </div>
        );
      case 'settings':
        return (
          <div className='dashboard-content-panel'>
            {alertSaved && (
              <div
                className={`job-alert-toast-${alertType === 'error' ? 'danger' : alertType === 'info' ? 'info' : 'success'}`}
                style={{ marginBottom: 20 }}
              >
                <i
                  className={`mdi ${alertType === 'error' ? 'mdi-alert-circle-outline' : alertType === 'info' ? 'mdi-information-outline' : 'mdi-check-circle-outline'}`}
                ></i>
                <span>{alertSaved}</span>
              </div>
            )}
            <h2>การตั้งค่า</h2>
            <p className='dashboard-subtitle'>จัดการการแจ้งเตือนและความเป็นส่วนตัว</p>

            <div className='settings-toggle-row'>
              <div className='settings-info'>
                <h4>รับการแจ้งเตือนงานใหม่ทางอีเมล</h4>
                <p>รับอีเมลเมื่อมีงานใหม่ตรงกับที่คุณค้นหา</p>
              </div>
              <label className='switch'>
                <input
                  type='checkbox'
                  checked={emailAlerts}
                  onChange={handleToggleEmailAlerts}
                />
                <span className='slider round'></span>
              </label>
            </div>

            <hr className='settings-divider' />

            <div className='settings-toggle-row'>
              <div className='settings-info'>
                <h4>แสดงโปรไฟล์เป็นสาธารณะ</h4>
                <p>ให้สถานพยาบาลสามารถค้นหาและดูโปรไฟล์ของคุณได้</p>
              </div>
              <label className='switch'>
                <input
                  type='checkbox'
                  checked={publicProfile}
                  onChange={handleTogglePublicProfile}
                />
                <span className='slider round'></span>
              </label>
            </div>
          </div>
        );
      default:
        return renderCandidateProfileForm();
    }
  };

  return (
    <div className='job-dashboard-page-container'>
      {/* Breadcrumbs */}
      <div className='job-dashboard-breadcrumbs'>
        <span onClick={() => navigate('/jobs')}>หางานสายสุขภาพ</span>
        <i className='mdi mdi-chevron-right'></i>
        <span className='active'>โปรไฟล์และเรซูเม่ผู้หางาน</span>
      </div>

      <div className='job-dashboard-layout'>
        {/* Sidebar Navigation */}
        <div className='dashboard-sidebar'>
          <div className='dashboard-user-card'>
            {profileData.avatar ? (
              <img src={profileData.avatar} alt='User Profile' className='user-avatar-circle' />
            ) : (
              <div className='user-avatar-placeholder-circle'>
                <i className='mdi mdi-account'></i>
              </div>
            )}
            <h3>{profileData.fullName || 'ผู้สมัครงาน MEYA'}</h3>
            <p>{profileData.email || profileData.phone || 'ยังไม่ได้ระบุอีเมล'}</p>
          </div>
          <div className='dashboard-nav-menu'>
            <div
              className={`dashboard-nav-item ${activeTab === 'profile' || activeTab === 'edit_candidate' ? 'active' : ''}`}
              onClick={() => handleTabChange('profile')}
            >
              <i className='mdi mdi-account-edit-outline'></i> สร้าง/แก้ไขโปรไฟล์
            </div>
            <div
              className={`dashboard-nav-item ${activeTab === 'searches' ? 'active' : ''}`}
              onClick={() => handleTabChange('searches')}
            >
              <i className='mdi mdi-magnify'></i> บันทึกการค้นหา
            </div>
            <div
              className={`dashboard-nav-item ${activeTab === 'saved_jobs' ? 'active' : ''}`}
              onClick={() => handleTabChange('saved_jobs')}
            >
              <i className='mdi mdi-heart-outline'></i> งานที่บันทึก
            </div>
            <div
              className={`dashboard-nav-item ${activeTab === 'history' ? 'active' : ''}`}
              onClick={() => handleTabChange('history')}
            >
              <i className='mdi mdi-history'></i> ประวัติการสมัครงาน
            </div>
            <div
              className={`dashboard-nav-item ${activeTab === 'notifications' ? 'active' : ''}`}
              onClick={() => handleTabChange('notifications')}
            >
              <i className='mdi mdi-bell-outline'></i> การแจ้งเตือน
            </div>
            <div
              className={`dashboard-nav-item ${activeTab === 'settings' ? 'active' : ''}`}
              onClick={() => handleTabChange('settings')}
            >
              <i className='mdi mdi-cog-outline'></i> การตั้งค่า
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className='dashboard-main-content'>{renderContent()}</div>
      </div>
    </div>
  );
}

export default JobProfileDashboard;
